"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _utils = require("./utils.js");
var _useDebounce = require("use-debounce");
var _ChartSettings = _interopRequireDefault(require("./ChartSettings.js"));
var _ChartTypeField = _interopRequireDefault(require("./ChartTypeField.js"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Settings = function Settings(props) {
  var currentMetric = props.currentMetric,
    currentMetricSettings = props.currentMetricSettings,
    currentCrossMetric = props.currentCrossMetric,
    updateMetricSettings = props.updateMetricSettings,
    cleanCurrentMetricVizData = props.cleanCurrentMetricVizData,
    metrics = props.metrics,
    groupComparisonOptions = props.groupComparisonOptions,
    data = props.data;
  var debouncedUpdateMetricSettings = (0, _useDebounce.useDebouncedCallback)(function (metric, values) {
    updateMetricSettings(metric, values);
  }, 200);
  var chartTypes = (0, _react.useMemo)(function () {
    return (0, _utils.getChartTypes)({
      metric: currentMetric,
      metricSettings: currentMetricSettings,
      crossMetric: currentCrossMetric
    });
  }, [currentMetric, currentMetricSettings, currentCrossMetric]);
  var compareWithOptions = (0, _utils.getCrosstabComparisonOptions)(metrics, currentMetric);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].title
  }, "Settings"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].form
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: currentMetricSettings,
    onAnyChange: function onAnyChange(values) {
      return debouncedUpdateMetricSettings(currentMetric, values);
    },
    onSubmit: function onSubmit() {},
    render: function render(_ref) {
      var values = _ref.values,
        setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "comparison",
        label: "Comparison",
        component: _cccisdFormik.CccisdSelect,
        options: (0, _utils.getComparisonOptions)(currentMetric).filter(function (opt) {
          return opt.value !== 'grouptype' || groupComparisonOptions.length > 0;
        }),
        onChange: function onChange(e) {
          var value = e.target.value;
          if (value === 'crosstab') {
            var firstElement = compareWithOptions.find(function (item) {
              return !item.disabled;
            });
            if (!firstElement) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: 'No metric to compare'
              });
            } else {
              cleanCurrentMetricVizData();
              setFieldValue('comparison', value);
              setFieldValue('compareWith', firstElement ? firstElement.value : '');
            }
          } else if (value === 'grouptype') {
            cleanCurrentMetricVizData();
            var _firstElement = groupComparisonOptions[0];
            setFieldValue('comparison', value);
            setFieldValue('compareByGroupType', _firstElement ? _firstElement.value : '');
          } else {
            cleanCurrentMetricVizData();
            setFieldValue('comparison', value);
          }
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "visualizeAs",
        label: "Visualize as",
        component: _cccisdFormik.CccisdSelect,
        options: (0, _utils.getVisualizeAsOptions)({
          metric: currentMetric,
          metricSettings: currentMetricSettings,
          crossMetric: currentCrossMetric
        })
      }), values.comparison === 'crosstab' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "compareWith",
        label: "Compare With",
        component: _cccisdFormik.CccisdSelect,
        options: compareWithOptions
      }), values.comparison === 'grouptype' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "compareByGroupType",
        label: "Compare By",
        component: _cccisdFormik.CccisdSelect,
        options: groupComparisonOptions
      }), chartTypes.length > 0 && /*#__PURE__*/_react["default"].createElement(_ChartTypeField["default"], {
        chartTypes: chartTypes
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartSettings
      }, /*#__PURE__*/_react["default"].createElement(_ChartSettings["default"], {
        name: "nivoOptions",
        type: values.chartType,
        data: data
        // showSummaryStatsToggle={
        //     // eslint-disable-next-line no-restricted-globals
        //     !isNaN(data[selectedMetric]?.min) || !isNaN(data[selectedMetric]?.max)
        // }
      })));
    }
  })));
};
Settings.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  updateMetricSettings: _propTypes["default"].func,
  cleanCurrentMetricVizData: _propTypes["default"].func,
  metrics: _propTypes["default"].array,
  groupComparisonOptions: _propTypes["default"].array,
  data: _propTypes["default"].object
};
var _default = exports["default"] = Settings;